import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { href: "#services", label: "Services" },
  { href: "#tarifs", label: "Tarifs" },
  { href: "#galerie", label: "Galerie" },
  { href: "#faq", label: "FAQ" },
  { href: "#devis", label: "Devis" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#f9f8f6]/85 backdrop-blur-xl border-b border-[#0a0a0a]/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className={`font-display text-2xl tracking-tight transition-colors duration-500 ${scrolled ? "text-[#0a0a0a]" : "text-white"}`}>
            FK<span className="text-gold">.</span>
          </span>
          <span className={`hidden text-[10px] font-medium uppercase tracking-[0.3em] transition-colors duration-500 sm:block ${scrolled ? "text-[#0a0a0a]/50" : "text-white/50"}`}>
            Conseil &amp; Événement
          </span>
        </a>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-xs font-medium uppercase tracking-[0.25em] transition-colors duration-300 ${
                scrolled ? "text-[#0a0a0a]/70 hover:text-[#aa8c2c]" : "text-white/75 hover:text-gold"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#devis"
          data-testid="nav-devis-cta"
          className="btn-blink rounded-full bg-gold px-6 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-[#0a0a0a]"
        >
          Devis
        </a>
      </div>
    </motion.header>
  );
};
